import { computed, inject, Injectable } from '@angular/core';
import { BaseGridViewState, BASE_GRID_VIEW_STATE } from '@data-access/extendables';

import { WcgFilterIndicatorsOptions } from '@shared/interfaces/wcg-table-utils.interface';

import {StudyListSignalState} from '../types';
import {updateGridFilter} from '../utils';

@Injectable({
  providedIn: 'root',
})
export class StudyListFacadeService extends BaseGridViewState {
  private readonly _studyGridStore = inject<StudyListSignalState>(BASE_GRID_VIEW_STATE);

  readonly $studies = computed(() => this._studyGridStore.$studies());
  readonly $currentUrl = computed(() => this._studyGridStore.$currentUrl());

  /**
   * NOTE: We are going forward with using inject() instead of constructor injection
   * But Super class needs to have the parameters passed in constructor
   * which we cannot do in the parent class for this specific signal store.
   * Hence, we are using inject() here and passing the values to super()
   */
  constructor() {
    super();
  }

  updateStudyGridFilter(filter: WcgFilterIndicatorsOptions) {
    const _constructFilter = updateGridFilter(
      filter,
      this._studyGridStore.$advancedFilters(),
    );
    this.updateGrid(
      'filter',
      {
        filters: _constructFilter.filters,
        page: this._studyGridStore.$pageView().page,
        pageSize: this._studyGridStore.$pageView().pageSize,
      },
      true,
      false,
    );
  }
}
